import { Button, Container, Input, Spacer, VDBText } from "@components/atoms";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useGlobalScreens } from "@redux/slices/globalSlice";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { handleAdLinkPress } from "@utils/product/productValidators";
import { VDBIcons } from "@utils/VDBIcons";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components/native";
import { JBTConnectedModalProps } from "./types";
import { useUserInfo } from "@redux/slices/userInfoSlice";

const JBTConnectedModal = ({ jbtID }: JBTConnectedModalProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const typography = useTypographyStore();
  const globalScreens = useGlobalScreens();
  const userInfo = useUserInfo();
  const jbtSetting = globalScreens?.jbt ?? {};

  return (
    <Container>
      <VDBText color={"core-05"} type={typography["Body-R"]}>
        {t("jbt.screenText.jbtConnectedHeader.text", {
          companyName: userInfo.companyName(),
        })}
      </VDBText>
      <Spacer size={SpaceType.Big} />
      <Input
        inputLabel={t("jbt.input.inputLabel.jbt.text")}
        placeholder={t("jbt.input.placeholder.jbt.text")}
        value={jbtID.toString()}
        rightIcon={VDBIcons.CHECKMARK}
        rightIconColor={theme["success-01"]}
        editable={false}
      />
      <Spacer size={SpaceType.Big} />
      <VDBText color={"core-06"} type={typography["Minor-R"]}>
        {t("jbt.screenText.jbtConnectedFooter.text")}
      </VDBText>
      <Spacer size={SpaceType.Big} />
      <VDBText color={"core-05"} type={typography["Body-R"]}>
        {t("jbt.screenText.notSureAboutFeatureMessage.text")}
      </VDBText>
      <Spacer size={SpaceType.Big} />
      <Button
        category={ButtonCategory.default}
        type={ButtonType.secondary}
        title={t("jbt.screenText.notSureAboutButtonMessage.text")}
        onPress={() => {
          handleAdLinkPress(jbtSetting?.jbtRedirectURL);
        }}
      />
      <Spacer size={SpaceType.ExtraLarge} />
    </Container>
  );
};

export default JBTConnectedModal;
